<div class="registered-ofwca-list-container">
  <div fxLayout="column" fxLayoutGap="15px">
    <div fxLayout="row" fxLayoutGap="15px">
      <button [disabled]="!(userPermissions | async).meeting.write" *ngIf="!protocolOpened && meetingObject.type.key !== MEETING_TYPE_NEW_AGENT_TRAINING" mat-stroked-button (click)="openProtocol()"><mat-icon>lock_open</mat-icon> Otwórz protokół</button>
      <button *ngIf="protocolOpened && meetingObject.type.key !== MEETING_TYPE_NEW_AGENT_TRAINING" [class.spinner]="processingRequest"
              [disabled]="processingRequest" mat-raised-button (click)="saveForms()">
        <mat-icon>lock</mat-icon> Zapisz i zamknij protokół
      </button>
      <button *ngIf="protocolOpened" (click)="cancel()"
              mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
      <button *ngIf="meetingObject.type.key === MEETING_TYPE_EXAM || meetingObject.type.key === MEETING_TYPE_ENTRANCE_EXAM" [class.spinner]="processingRequest"
              [disabled]="processingRequest || !(userPermissions | async).meeting.write"
              mat-stroked-button (click)="importData()"
              matTooltip="Kolumny: PESEL, Punktacja 1, Punktacja 2, Zaliczony egzamin (Tak/Nie)"
              matTooltipPosition="above"
      >
        <mat-icon>file_upload</mat-icon> Importuj
      </button>
      <button *ngIf="(userPermissions | async).meeting.read_report" [disabled]="!(userPermissions | async).meeting.read_report" mat-stroked-button (click)="downloadReport()">
        <mat-icon>download</mat-icon> Raport
      </button>
      <button [disabled]="!(userPermissions | async).meeting.write" mat-stroked-button (click)="sendToInsuranceCompany()" *ngIf="meetingObject.type.key === MEETING_TYPE_EXAM || meetingObject.type.key === MEETING_TYPE_ENTRANCE_EXAM">
        <mat-icon>send</mat-icon> Zapisz i wyślij do rejestracji
      </button>
      <button *ngIf="meetingObject.type.key !== MEETING_TYPE_NEW_AGENT_TRAINING" [disabled]="!(userPermissions | async).meeting.write" mat-stroked-button (click)="downloadDocuments()">
        <mat-icon>download</mat-icon> Dokumenty
      </button>

      <input #importSelect type="file" style="display: none" [formControl]="fileImportSelectControl"
             accept=".xlsx"/>
      <button [disabled]="!(userPermissions | async).meeting.write"
              *ngIf="meetingObject.type.key === MEETING_TYPE_IDD_TRAINING " mat-stroked-button (click)="downloadCertificates()">
        <mat-icon>download</mat-icon> Generuj zaświadczenia
      </button>

      <button [disabled]="!(userPermissions | async).meeting.write"
              *ngIf="meetingObject.type.key === MEETING_TYPE_IDD_TRAINING" mat-stroked-button (click)="sendCertificates()">
        <mat-icon>mail</mat-icon> Wyślij zaświadczenia
      </button>
    </div>

    <div>
      <table mat-table [dataSource]="ofwcaMeetingDataSource" matSort (matSortChange)="sortChanged($event)">
        <ng-container matColumnDef="export">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox color="accent" [formControl]="selectAllControl"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox  color="accent" [formControl]="element.form.get('export')"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="ofwca">
          <th mat-header-cell *matHeaderCellDef> OFWCA </th>
          <td mat-cell *matCellDef="let element">
            <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwcaMeeting.ofwca.uuid]">
              {{element.ofwcaMeeting.ofwca.fullName}}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="dateOfRegistrationForNewAgentTraining">
          <th mat-header-cell *matHeaderCellDef> Data zapisania </th>
          <td mat-cell *matCellDef="let element">
            <a *ngIf="element?.ofwcaMeeting?.createdAt">{{element?.ofwcaMeeting?.createdAt | date: 'yyyy-MM-dd HH:mm' }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="ofwcaLastName">
          <th mat-header-cell mat-sort-header="ofwcaLastName" *matHeaderCellDef> Nazwisko </th>
          <td mat-cell *matCellDef="let element">
            {{element?.ofwcaMeeting?.ofwca?.lastName}}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let element">
            <button mat-raised-button [ngClass]="element.ofwcaMeeting.ofwca.status.color + '-button'">{{element.ofwcaMeeting.ofwca.status.name}}</button>
          </td>
        </ng-container>

        <ng-container matColumnDef="pesel">
          <th mat-header-cell *matHeaderCellDef> PESEL </th>
          <td mat-cell *matCellDef="let element">
            {{element.ofwcaMeeting.ofwca?.pesel}}
          </td>
        </ng-container>

        <ng-container matColumnDef="partner">
          <th mat-header-cell *matHeaderCellDef> Partner </th>
          <td mat-cell *matCellDef="let element">
            <a *ngIf="element.ofwcaMeeting.ofwca?.partner" class="default-link" [routerLink]="['/partnerzy/szczegoly', element.ofwcaMeeting.ofwca?.partner?.uuid]">{{element.ofwcaMeeting.ofwca?.partner?.shortName}}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="ofwcaAssetsRegional">
          <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) OFWCA </th>
          <td mat-cell *matCellDef="let element">
            {{element.ofwcaMeeting.ofwca.assetsRegional?.fullName}}
          </td>
        </ng-container>

        <ng-container matColumnDef="partnerAssetsRegional">
          <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) Partnera </th>
          <td mat-cell *matCellDef="let element">
            {{element.ofwcaMeeting.ofwca?.partner?.assetsRegionalFullName}}
          </td>
        </ng-container>

        <ng-container matColumnDef="activeKrk">
          <th mat-header-cell *matHeaderCellDef> Aktywne KRK </th>
          <td mat-cell *matCellDef="let element" class="center-cell">
            <button *ngIf="element.ofwcaMeeting.ofwca?.hasActiveKrk" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
            <button *ngIf="!element.ofwcaMeeting.ofwca?.hasActiveKrk" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
            <ng-container *ngIf="element.ofwcaMeeting.ofwca.hasActiveKrk">({{element.ofwcaMeeting.ofwca.krkActiveTo | daysDiff}}&nbsp;dni)</ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="points1">
          <th mat-header-cell *matHeaderCellDef> Punktacja 1 </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field *ngIf="protocolOpened" class="points-field">
              <input [required]="false" type="number" matInput [formControl]="$any(element.form.get('points1'))">
            </mat-form-field>
            <ng-container *ngIf="!protocolOpened">
              {{element.ofwcaMeeting.points1}}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="points2">
          <th mat-header-cell *matHeaderCellDef> Punktacja 2 </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field *ngIf="protocolOpened" class="points-field">
              <input [required]="false" type="number" matInput [formControl]="$any(element.form.get('points2'))">
            </mat-form-field>
            <ng-container *ngIf="!protocolOpened">
              {{element.ofwcaMeeting.points2}}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="passedTest">
          <th mat-header-cell *matHeaderCellDef>
            <ng-container *ngIf="!protocolOpened">Zdany test</ng-container>
            <mat-checkbox *ngIf="protocolOpened" color="accent" [formControl]="allPassedTestControl">Zdany test</mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element">
            <app-slide-form-field *ngIf="protocolOpened" [formControl]="element.form.get('passedTest')" label=""></app-slide-form-field>
            <app-detail-bool *ngIf="!protocolOpened" [value]="element.ofwcaMeeting.passedTest"></app-detail-bool>
          </td>
        </ng-container>

        <ng-container matColumnDef="passedExam">
          <th mat-header-cell *matHeaderCellDef> Zaliczony egzamin </th>
          <td mat-cell *matCellDef="let element">
            <app-slide-form-field *ngIf="protocolOpened" [formControl]="element.form.get('passed')" label=""></app-slide-form-field>
            <app-detail-bool *ngIf="!protocolOpened" [value]="element.ofwcaMeeting.passed"></app-detail-bool>
          </td>
        </ng-container>

        <ng-container matColumnDef="passedIddTraining">
          <th mat-header-cell *matHeaderCellDef>
            <ng-container *ngIf="!protocolOpened">Zaliczone szkolenie</ng-container>
            <mat-checkbox *ngIf="protocolOpened" color="accent" [formControl]="allPassedIddTrainingControl">Zaliczone szkolenie</mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element">
            <app-slide-form-field *ngIf="protocolOpened" [formControl]="element.form.get('passed')" label=""></app-slide-form-field>
            <app-detail-bool *ngIf="!protocolOpened" [value]="element.ofwcaMeeting.passed"></app-detail-bool>
          </td>
        </ng-container>

        <ng-container matColumnDef="attachedCertificate">
          <th mat-header-cell *matHeaderCellDef>
            Załączone zaświadczenie
          </th>
          <td mat-cell *matCellDef="let element">
            <app-detail-bool [value]="!!element.ofwcaMeeting.iddTrainingCertificate"></app-detail-bool>
          </td>
        </ng-container>

        <ng-container matColumnDef="sentAt">
          <th mat-header-cell *matHeaderCellDef> Data wysłania </th>
          <td mat-cell *matCellDef="let element">
            {{element.ofwcaMeeting.sentAt | date:'dd-MM-y'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>  </th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button color="accent" (click)="sendCertificate(element.ofwcaMeeting)"
                    *ngIf="meetingObject.type.key === MEETING_TYPE_IDD_TRAINING"
                    [disabled]="!element.ofwcaMeeting.iddTrainingCertificate ||!(userPermissions | async).meeting.write"
            ><mat-icon>mail</mat-icon></button>
            <button mat-icon-button color="accent" (click)="downloadCertificate(element.ofwcaMeeting)"
                    *ngIf="meetingObject.type.key === MEETING_TYPE_IDD_TRAINING"
                    [disabled]="!element.ofwcaMeeting.passed || !element.ofwcaMeeting.passedTest ||!(userPermissions | async).meeting.write"
            ><mat-icon>download</mat-icon></button>
            <button mat-icon-button color="warn" (click)="deregisterOfwca(element.ofwcaMeeting)"
              [disabled]="meetingObject.status.key !== MEETING_STATUS_DURING_REGISTRATIONS || !(userPermissions | async).meeting.read_and_sign_up"
            ><mat-icon>delete</mat-icon></button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
    </div>

  </div>

</div>
